var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE6C",
    d: "M10.86 17.04a6.18 6.18 0 0 0 2.348-11.897a6.917 6.917 0 1 1-8.065 8.066a6.18 6.18 0 0 0 5.717 3.831"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1B4",
    d: "M17.04 10.86a6.18 6.18 0 0 1-9.789 5.015a6.18 6.18 0 1 0 8.37-8.953a6.15 6.15 0 0 1 1.414 3.943z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC705",
    d: "M5.374 11.52c.197 1.535 1.551 4.672 5.409 4.933c-.759-4.487-3.922-5.16-5.409-4.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0082E4",
    d: "M16.53 11.52c-.193 1.535-1.552 4.672-5.409 4.933c.763-4.487 3.926-5.16 5.409-4.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52C9C7",
    d: "M10.68 14.953c.133.317.24.78.278.973c.176-1.187 1.179-3.733 3.78-4.423c.005-.686-.064-2.229-.364-2.966c-3.39 1.547-3.874 4.92-3.694 6.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADD004",
    d: "M10.384 14.25c-.986-1.958-2.537-2.653-3.189-2.751c-.03-.545-.008-1.895.335-2.949c2.121.994 3.068 2.683 3.274 3.407a6.6 6.6 0 0 0-.42 2.293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CCC4E",
    d: "M9.407 9.497a7.9 7.9 0 0 1 1.568 2.13c.232-.475.866-1.572 1.543-2.13c-.21-.544-.805-1.808-1.543-2.515c-.758.698-1.362 1.971-1.568 2.515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWell);
export default __webpack_public_path__ + "static/media/well.4f64670bd495e17cab88d4c39cb018e3.svg";
export { ForwardRef as ReactComponent };